<div class="breadcrumbs">
    <p-breadcrumb *ngIf="breadcrumb?.length"
        [home]="{routerLink: '/', icon: 'fa fa-fw fa-home'}"
        [model]="breadcrumb"
        styleClass="breadcrumb"
    ></p-breadcrumb>
</div>
